export const timeFilterValueProcessing = (timeFilterValue: string) => {
  const timeFilterValueNumber = Number(timeFilterValue);

  const isValidTimeFilterValue = timeFilterValue && !Number.isNaN(timeFilterValueNumber);

  return {
    timeFilterValueNumber,
    isValidTimeFilterValue,
  };
};
